/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Rent = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <g clipPath="url(#clip0_10306_308)">
                        <path
                            d="M11.35 18.31H12.69V17.11C14.3 16.93 15.31 15.98 15.31 14.6C15.31 12.93 14.28 12.36 13.07 12.01L11.65 11.61C11.06 11.44 10.68 11.19 10.68 10.66C10.68 10.06 11.18 9.70999 12.04 9.70999C12.96 9.70999 13.54 10.24 13.65 10.87H15.23C15.13 9.48999 14.16 8.54999 12.7 8.33999V7.23999H11.36V8.33999C9.98001 8.56999 9.04001 9.46999 9.04001 10.67C9.04001 12.19 10.04 12.81 11.22 13.14L12.64 13.54C13.24 13.71 13.68 14.04 13.68 14.63C13.68 15.29 13.04 15.73 12.12 15.73C11.14 15.73 10.36 15.03 10.28 14.12H8.70001C8.80001 15.7 9.84001 16.8 11.35 17.06V18.3V18.31Z"
                            fill={color}
                        />
                        <path d="M13.5 21.49H14H21V19.99H15.46H15H13.5V21.49Z" fill={color} />
                        <path
                            d="M21 18.49V10.16C21 9.73 20.82 9.32 20.5 9.04L13 2.38C12.43 1.87 11.58 1.87 11.01 2.38L3.5 9.05C3.18 9.33 3 9.74 3 10.17V21.5H4H13.25H13.75V20H4.5V10.17L12 3.5L19.5 10.17V18.5H21V18.49Z"
                            fill={color}
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_10306_308">
                            <rect
                                width="18"
                                height="19.49"
                                fill="white"
                                transform="translate(3 2)"
                            />
                        </clipPath>
                    </defs>
                </svg>
        );
    };
